export default "__VITE_ASSET__ffe14096__"